/**
 * WhatsApp Community invite links:
 * https://chat.whatsapp.com/<inviteCode>
 * Invite codes are typically 16–32 alphanumeric characters.
 */
export const WHATSAPP_COMMUNITY_LINK_REGEX =
  /^https:\/\/chat\.whatsapp\.com\/[A-Za-z0-9]{16,32}(?:\?[A-Za-z0-9_=&%-]*)?$/i;

const WHATSAPP_COMMUNITY_LINK_ERROR =
  'Enter a valid WhatsApp Community link (https://chat.whatsapp.com/…)';

/** Trim ends and strip any embedded whitespace from a pasted WhatsApp link. */
export const normalizeWhatsAppCommunityLink = (value) =>
  String(value ?? '')
    .trim()
    .replace(/\s+/g, '');

export const isValidWhatsAppCommunityLink = (value) => {
  const normalized = normalizeWhatsAppCommunityLink(value);
  return Boolean(normalized) && WHATSAPP_COMMUNITY_LINK_REGEX.test(normalized);
};

export const validateOptionalWhatsAppCommunityLink = (value) => {
  const normalized = normalizeWhatsAppCommunityLink(value);
  if (!normalized) return '';
  if (!WHATSAPP_COMMUNITY_LINK_REGEX.test(normalized)) {
    return WHATSAPP_COMMUNITY_LINK_ERROR;
  }
  return '';
};
